export const removeEmpty = <T>(obj: Record<string, any>, removeEmptyArrays: boolean = false): Partial<T> =>
    Object.fromEntries(
        Object.entries(obj).filter(([_, v]) =>
            Array.isArray(v) && removeEmptyArrays ? Boolean(v ? v.length : v) : v || v === 0 || v === false || v === ''
        )
    ) as Partial<T>;
